import { render, staticRenderFns } from "./tit-primary.vue?vue&type=template&id=09f091ea&"
import script from "./tit-primary.vue?vue&type=script&lang=js&"
export * from "./tit-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports